import {ButtonGroup} from '@kit';

import React from 'react';

import {SourceBook} from '../../../generated/types';
import {enumList, Filters, FiltersPopup} from '../../../components/filters';
import {sourceBookToString} from '../../../components/enums';

const SOURCES = [
	SourceBook.XPHB,
	SourceBook.XDMG,
	SourceBook.XMM,
	SourceBook.AU,
	SourceBook.FRHoF,
	SourceBook.FRAiF,
	SourceBook.PaBTSO,
	SourceBook.ToD,
	SourceBook.DDBD,
];

export const monsterFilters = {
	sources: enumList('source', SOURCES),
};

type Props = {
	filters: Filters<typeof monsterFilters>;
};

export const MonsterFilters: React.FC<Props> = ({filters}) => (
	<FiltersPopup filters={filters} header="Фильтровать чудовищ">
		<li>
			<ButtonGroup
				items={SOURCES}
				itemToHtml={sourceBookToString}
				multiple
				label="Источник"
				{...filters.field('sources')}
			/>
		</li>
	</FiltersPopup>
);
